<span *ngIf="errorMessage" [innerHTML]="errorMessage" class="text-danger"></span>

<span *ngIf="saved" [innerHTML]="successMessage" class="text-success"></span>
